import queryString, { UrlObject, StringifyOptions } from 'query-string';

import { MeetingCode } from '@tencent/wemeet-websdk-next';
import { filterDigit } from './string';

/**
 * 从链接 /r/xxxx 提取 meetingCode
 *
 * FIXME: 如果路由形式变了，那么就会有问题
 * @returns MeetingCode
 */
export const getMeetingCodeFromUrl = (): MeetingCode => filterDigit(new URL(window.location.href).pathname);

/**
 * 获取当前页面的 queryObject
 * @returns
 */
export const getQueryObj = () => queryString.parseUrl(window.location.href).query;

/**
 *
 * 给链接增加查询参数、hash值
 *
 * 支持源链接 有/无查询参数，有/无 hash 值
 * @param object
 * @param options
 * @returns
 */
export const addURLSearch = (object: UrlObject, options?: StringifyOptions) =>
  queryString.stringifyUrl(object, options);
